import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';

import { SessionSiteSelectors } from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { OmniboxOwnProps, OmniboxStateProps, OmniboxV2 } from './OmniboxV2';

const mapStateToProps: MapStateToProps<OmniboxStateProps> = (state: AppState) => ({
  siteRole: SessionSiteSelectors.siteRole(state),
});

export const ConnectedOmnibox: React.ComponentClass<OmniboxOwnProps> = connect(mapStateToProps)(OmniboxV2);
